import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import MDTypography from 'components/MDTypography';
import ButtonGroup from '@mui/material/ButtonGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';

export const FilterDataButtonGroup = styled(ButtonGroup)`
  height: 40;
  width: 100%;
  borderradius: 2;
  overflow: hidden;
`;

export const FilterPresetButton = styled(Button)`
  flex-grow: 1;
  color: #1976d2;
  text-transform: none;
`;

export const FilterPresetEditButton = styled(Button)`
  width: 40;
  min-width: 40;
  color: #1976d2;
`;

export const FilterPresetLoaderGrid = styled(Grid)`
  display: flex;
  justify-content: center;
`;

export const StudentProfileTabCard = styled(Card)`
  padding: 16px 24px;
`;

export const StudentProfileBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AttendanceSessionGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
`;

export const InComplianceGrid = styled(Grid)`
  display: flex;
`;

export const EmptyMessageBox = styled(MDBox)`
  padding: 20px;
  color: #666;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
`;

export const TrackerColumnFormControl = styled(FormControlLabel)`
  display: flex;
  align-items: center;

  & .MuiFormControlLabel-label {
    font-weight: 400;
    font-size: 0.95rem;
  }
`;

export const SsaTextBox = styled(Box)`
  padding: 0px 24px 0px 24px;
`;

export const SsaSidebarListWrapper = styled(MDBox)`
  display: flex;
  margin-top: 16px;
  flex-direction: column;
`;

export const DataUnavailableText = styled(Typography)`
  opacity: 0.8;
  margin-left: 8px;
  font-size: 12px;
`;

export const SsaSidebarStudentItem = styled(MDBox)(
  ({ isactive, isapierror }) => ({
    background: isactive
      ? 'rgb(230, 230, 230)' // Active
      : isapierror
        ? '#666666' // API failed
        : '#1A73E8', // Normal

    fontWeight: 300,
    fontSize: '14px',
    cursor: 'pointer',
    borderRadius: '8px',
    padding: '10px 12px',
    marginBottom: '10px',
    color: isactive ? '#000' : 'white',

    opacity: isapierror && !isactive ? 0.7 : 1,
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    whiteSpace: 'normal',
    flexDirection: 'row',
    wordBreak: 'break-word',

    // optional: smooth background transitions
    transition: '0.2s ease',
    '&:hover': {
      opacity: 1,
    },
  }),
);

export const SidebarCheckBoxIcon = styled(CheckBoxTwoToneIcon)`
  font-size: 24px !important;
  color: ${(props) => (props?.isactive ? `green` : 'lawngreen')};
`;

export const SsaSectionTypography = styled(MDTypography)`
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
`;

export const GridRightAction = styled(Grid)`
  padding-top: 0;
  display: flex;
  justify-content: flex-end;
`;

export const CannedResponsesWrapper = styled(Grid)`
  padding: 0px 10px;
  position: relative;
  border-radius: 5px;
  margin-bottom: 10px;
  background-color: #dcdcdc;

  .copy-btn {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover .copy-btn {
    opacity: 1;
  }
`;
